import { render, staticRenderFns } from "./PluginTableSortSkeleton.vue?vue&type=template&id=13ac64bd&scoped=true"
import script from "./PluginTableSortSkeleton.vue?vue&type=script&lang=js"
export * from "./PluginTableSortSkeleton.vue?vue&type=script&lang=js"
import style0 from "./PluginTableSortSkeleton.vue?vue&type=style&index=0&id=13ac64bd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ac64bd",
  null
  
)

export default component.exports